import {
    Box,
    Table,
    Thead,
    Tr,
    Tbody,
    Td,
    Th,
    Button,
    Text,
    HStack,
    Flex,
    Spacer
  } from "@chakra-ui/react";
  import { format, addDays, startOfDay, isSameDay, isToday } from "date-fns";
  import { useState, useEffect } from "react";
  import { CalendarIcon } from '@chakra-ui/icons'
  
  const CalendarDate = ({ onDateChange }) => {
    const [selectedDate, setSelectedDate] = useState(startOfDay(new Date()));
    const [currentDate, setCurrentDate] = useState(startOfDay(new Date()));
    const [dates, setDates] = useState([]);
  
    useEffect(() => {
      const newDates = [];
      for (let i = 0; i < 5; i++) {
        newDates.push(addDays(currentDate, i));
      }
      setDates(newDates);
    }, [currentDate]);

    useEffect(() => {
      onDateChange(selectedDate);
    }, [selectedDate, onDateChange]);
  
    return (
      <Flex 
        direction="column" 
        display="flex" 
        overflowY="auto" 
        marginTop={3}
        borderRadius="lg"
        p={4}
        bg="white"
        boxShadow="0 4px 12px rgba(0, 0, 0, 0.05)"
      >
        <HStack marginBottom={4}>
            <CalendarIcon color="#82ca9c" /> 
            <Text fontWeight="600">Select a date</Text>
            <Spacer />
        </HStack>
        <HStack justify="space-between" mb={3}>
          <HStack>
            <Button 
              onClick={() => setCurrentDate(addDays(currentDate, -5))}
              size="sm"
              variant="ghost"
              colorScheme="green"
              borderRadius="full"
              h="32px"
              minW="32px"
              p={0}
            >
              &lt;
            </Button>
            <Text fontWeight="medium" px={2}>{format(currentDate, "MMMM yyyy")}</Text>
            <Button 
              onClick={() => setCurrentDate(addDays(currentDate, 5))}
              size="sm"
              variant="ghost"
              colorScheme="green"
              borderRadius="full"
              h="32px"
              minW="32px"
              p={0}
            >
              &gt;
            </Button>
          </HStack>
        </HStack>
        <Box 
          bg="#f8f9fa" 
          borderRadius="md" 
          py={2} 
          px={1}
        >
          <Table variant="unstyled" size="sm">
            <Thead>
              <Tr>
                {dates.map((date, index) => (
                  <Th 
                    key={index} 
                    textAlign="center"
                    fontWeight="600"
                    fontSize="xs"
                    color="gray.600"
                    textTransform="uppercase"
                    py={2}
                    px={1}
                  >
                    {format(date, "EEE")}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                {dates.map((date, index) => (
                  <Td
                    key={index}
                    onClick={() => setSelectedDate(date)}
                    textAlign="center"
                    cursor="pointer"
                    p={2}
                  >
                    <Box
                      borderRadius="full"
                      w="36px"
                      h="36px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      mx="auto"
                      bg={isSameDay(selectedDate, date) ? "#82ca9c" : isToday(date) ? "rgba(130, 202, 156, 0.1)" : "transparent"}
                      color={isSameDay(selectedDate, date) ? "white" : isToday(date) ? "#82ca9c" : "inherit"}
                      fontWeight={isSameDay(selectedDate, date) || isToday(date) ? "bold" : "normal"}
                      boxShadow={isSameDay(selectedDate, date) ? "0 2px 6px rgba(130, 202, 156, 0.4)" : "none"}
                      transition="all 0.2s"
                      _hover={{
                        bg: isSameDay(selectedDate, date) ? "#82ca9c" : "rgba(130, 202, 156, 0.1)",
                        transform: "scale(1.05)",
                      }}
                    >
                      {format(date, "dd")}
                    </Box>
                  </Td>
                ))}
              </Tr>
            </Tbody>
          </Table>
        </Box>
      </Flex>
    );
  };
  export default CalendarDate;